import MuiAlert, {
  AlertProps,
} from '@material-ui/lab/Alert';

export default function AppAlert(props: AlertProps) {
  return <MuiAlert elevation={0} variant="filled" {...props} />;
}
